import { render, staticRenderFns } from "./TreeDetails.vue?vue&type=template&id=6c9f55e8&"
import script from "./TreeDetails.vue?vue&type=script&lang=js&"
export * from "./TreeDetails.vue?vue&type=script&lang=js&"
import style0 from "./TreeDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TreeDetails.vue"
export default component.exports